// extracted by mini-css-extract-plugin
export default {"superSpeedButtonWrapper":"super-speed-button__superSpeedButtonWrapper___OrwzT","superSpeedButton":"super-speed-button__superSpeedButton___IeQxr"};